"use client";

import { useGovernmentAgencies } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import type { Kh_Government_Agencies } from "@sisnaker-react-core/karirhub-model-type";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface GovernmentAgencyComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
}

export const GovernmentAgencyCombobox = ({ initialValue, onChange, onClear, disabled }: GovernmentAgencyComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { governmentAgencies, isLoading } = useGovernmentAgencies({ keyword, enabled: !disabled, limit: 5 });

  const options: ComboboxOption[] = governmentAgencies.map((agency: Kh_Government_Agencies) => ({
    value: agency.id,
    label: agency.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih lembaga/instansi"
      searchPlaceholder="Cari lembaga/instansi..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
